"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runMacroOnChangeSet = exports.runMacroOnRow = exports.runMacroOnValue = exports.compileMacroFunction = void 0;
const lodash_1 = __importDefault(require("lodash"));
const v1_1 = __importDefault(require("uuid/v1"));
const v4_1 = __importDefault(require("uuid/v4"));
const moment_1 = __importDefault(require("moment"));
const ChangeSet_1 = require("./ChangeSet");
const getMacroFunction = {
    transformValue: code => `
(value, args, modules, rowIndex, row, columnName) => {
    ${code}
}
`,
    transformRow: code => `
(row, args, modules, rowIndex, columns) => {
  ${code}
}
`,
};
const modules = {
    lodash: lodash_1.default,
    uuidv1: v1_1.default,
    uuidv4: v4_1.default,
    moment: moment_1.default,
};
function compileMacroFunction(macro, errors = []) {
    if (!macro)
        return null;
    let func;
    try {
        func = eval(getMacroFunction[macro.type](macro.code));
        return func;
    }
    catch (err) {
        errors.push(`Error compiling macro ${macro.name}: ${err.message}`);
        return null;
    }
}
exports.compileMacroFunction = compileMacroFunction;
function runMacroOnValue(compiledFunc, macroArgs, value, rowIndex, row, column, errors = []) {
    if (!compiledFunc)
        return value;
    try {
        const res = compiledFunc(value, macroArgs, modules, rowIndex, row, column);
        return res;
    }
    catch (err) {
        errors.push(`Error processing column ${column} on row ${rowIndex}: ${err.message}`);
        return value;
    }
}
exports.runMacroOnValue = runMacroOnValue;
function runMacroOnRow(compiledFunc, macroArgs, rowIndex, row, columns, errors = []) {
    if (!compiledFunc)
        return row;
    try {
        const res = compiledFunc(row, macroArgs, modules, rowIndex, columns);
        return res;
    }
    catch (err) {
        errors.push(`Error processing row ${rowIndex}: ${err.message}`);
        return row;
    }
}
exports.runMacroOnRow = runMacroOnRow;
function runMacroOnChangeSet(macro, macroArgs, selectedCells, changeSet, display, useRowIndexInsteaOfCondition) {
    var _a;
    const errors = [];
    const compiledMacroFunc = compileMacroFunction(macro, errors);
    if (!compiledMacroFunc)
        return null;
    if (macro.type == 'transformValue') {
        let res = changeSet;
        for (const cell of selectedCells) {
            const definition = display.getChangeSetField(cell.rowData, cell.column, undefined, useRowIndexInsteaOfCondition ? cell.row : undefined, useRowIndexInsteaOfCondition);
            const macroResult = runMacroOnValue(compiledMacroFunc, macroArgs, cell.value, cell.row, cell.rowData, cell.column, errors);
            res = (0, ChangeSet_1.setChangeSetValue)(res, definition, macroResult);
        }
        return res;
    }
    if (macro.type == 'transformRow') {
        let res = changeSet;
        const rowIndexes = lodash_1.default.uniq(selectedCells.map(x => x.row));
        for (const index of rowIndexes) {
            const rowData = (_a = selectedCells.find(x => x.row == index)) === null || _a === void 0 ? void 0 : _a.rowData;
            const columns = lodash_1.default.uniq(selectedCells.map(x => x.column));
            const definition = display.getChangeSetRow(rowData, null, index, true);
            const newRow = runMacroOnRow(compiledMacroFunc, macroArgs, index, rowData, columns);
            res = (0, ChangeSet_1.setChangeSetRowData)(res, definition, newRow);
        }
        return res;
    }
}
exports.runMacroOnChangeSet = runMacroOnChangeSet;
